import React from "react";
import { Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import HomeAll from "./containers/HomeAll";
import GamesAll from "./containers/Games";
import GameDetailPage from "./components/gameDetailPage";
import OurSTory from "./containers/OurStory";
import NewsAll from "./containers/News";
import SupportAll from "./containers/Support";
import ContactAll from "./containers/Contact";
import ContactSeenaApps from "./containers/Contact-Seena";
import FooterAll from "./components/Footer/footer";
import CareersAll from "./containers/Careers";
import DeveloperAll from "./containers/Developers";
import "./App.scss";

const App = () => {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<HomeAll />} />
        <Route path="/games" element={<GamesAll />} />
        <Route path="/game-detail/:gameId" element={<GameDetailPage />} />
        <Route path="/about-us" element={<OurSTory />} />
        <Route path="/news" element={<NewsAll />} />
        <Route path="/support" element={<SupportAll />} />
        <Route path="/contact" element={<ContactAll />} />
        <Route path="/contact-seena-apps" element={<ContactSeenaApps />} />
        <Route path="/careers" element={<CareersAll />} />
        <Route path="/developers" element={<DeveloperAll />} />
      </Routes>
      <FooterAll />
    </>
  );
};

export default App;
